import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { styledLayout } from '@pkg/primitives';

import { statusGradientTransition, StatusGradientVariant, statusGradientVariants } from '../../TicksMeter.motion';
import { tokens } from '../../tokens';
import { TickStatus } from '../../types';

interface ColorFillProps {
    $status?: TickStatus;
}
export const StyledStatusGradient = styled(motion.div).attrs({
    variants: statusGradientVariants,
    initial: StatusGradientVariant.Hidden,
    animate: StatusGradientVariant.Show,
    exit: StatusGradientVariant.Hidden,
    transition: statusGradientTransition,
})`
    ${styledLayout.positionCover()};
    z-index: ${tokens.zIndex.status};
    overflow: hidden;
    background-color: ${tokens.colors.statusBase};
`;

export const ColorFill = styled(motion.div).attrs({
    variants: statusGradientVariants,
    initial: StatusGradientVariant.Hidden,
    animate: StatusGradientVariant.Show,
    exit: StatusGradientVariant.Hidden,
    transition: statusGradientTransition,
})<ColorFillProps>`
    ${styledLayout.positionCover()};
    background: linear-gradient(${tokens.colors.statusNeutral}, transparent);

    ${({ $status }) => {
        if ($status === TickStatus.Negative) {
            return css`
                background: linear-gradient(${tokens.colors.statusNegative}, transparent 140%);
            `;
        }

        if ($status === TickStatus.Positive) {
            return css`
                background: linear-gradient(${tokens.colors.statusPositive}, transparent 110%);
            `;
        }
    }};
`;
